import React, { useState } from "react";

import { useMutation } from "@apollo/client";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Notification from "shared/components/Notification";
import { StepStore } from "shared/components/Tab";
import { UPDATE_FOLDER } from "shared/graphql/mutations";
import { DEFAULT_VALUES, NAME_SPACES } from "shared/locals/constants";

import View from "./View";

const Component = ({
  folder,
  folderStatus,
  onBack,
  actionCode,
  step: { onReset },
  onStatusUpdate,
}) => {
  const { t: tError } = useTranslation(NAME_SPACES.ERRORS);
  const [loading, setLoading] = useState(false);

  const [updateFolder] = useMutation(UPDATE_FOLDER, {
    onError: () => {
      Notification.error({
        duration: DEFAULT_VALUES.NOTIFICATION_DURATION,
        message: tError("GENERIC"),
      });
      setLoading(false);
    },
  });

  /**
   * Submit operation handler. The handler execute folder update operation (WS) and then given `onStatusUpdate` handler.
   * @param _data submit related data
   * @returns {Promise<void>}
   */
  const onSubmit = async (_data) => {
    setLoading(true);
    const data = Object.entries(_data).reduce(
      (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
      {},
    );
    await updateFolder({
      variables: {
        where: { folderNum: folder?.folderNum },
        data: { ...data },
      },
    });
    await onStatusUpdate(data);
    onReset();
    setLoading(false);
  };

  const _onBack = () => {
    onReset();
    onBack();
  };

  return (
    <View
      folder={folder}
      folderStatus={folderStatus}
      actionCode={actionCode}
      loading={loading}
      onSubmit={onSubmit}
      onBack={_onBack}
    />
  );
};

Component.propTypes = {
  step: PropTypes.shape({
    onReset: PropTypes.func.isRequired,
  }).isRequired,
  folder: PropTypes.shape({
    productCode: PropTypes.string,
    folderNum: PropTypes.string.isRequired,
  }),
  folderStatus: PropTypes.shape({
    processCode: PropTypes.string,
    statusCode: PropTypes.string,
  }).isRequired,
  actionCode: PropTypes.string,
  onBack: PropTypes.func,
  onStatusUpdate: PropTypes.func.isRequired,
};
Component.defaultProps = {
  onBack: () => {},
};

export default StepStore(Component);
